import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import locale from "date-fns/locale/ru";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { FC } from "react";
import type { CustomDatePickerProps } from "./date-picker.types";
import { StyledDatePicker } from "./date-picker.styles";

export const CustomDatePicker: FC<CustomDatePickerProps> = (
  params,
  { label }
) => {
  const { views } = params;

  // set week's start day to monday
  if (locale && locale.options) {
    locale.options.weekStartsOn = 1;
  }

  let format = "dd/MM/yyyy";

  return (
    <StyledDatePicker>
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={locale}>
        <DatePicker
          {...params}
          label={label}
          format={format}
          sx={{ width: 210 }}
          slotProps={{ textField: { placeholder: "dd/mm/yyyy" } }}
        />
      </LocalizationProvider>
    </StyledDatePicker>
  );
};
